// src/services/serviceFeeService.ts

import apiClient from "./apiClient";

// Define the shape of the Service Fee object based on your API
export interface ServiceFee {
  id: string;
  percentage: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Fetches the current service fee from the API.
 */
export const getCurrentServiceFee = async (): Promise<ServiceFee | null> => {
  try {
    const response = await apiClient.get<ServiceFee | null>(
      "service-charge/current",
    );
    return response.data ?? null;
  } catch (error) {

    throw error;
  }
};

/**
 * Updates the service fee percentage.
 * @param percentage The new percentage value.
 */
export const updateServiceFee = async (
  percentage: number,
): Promise<ServiceFee> => {
  try {
    const payload = { percentage };
    const response = await apiClient.post<ServiceFee>(
      "service-charge/update",
      payload,
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};
